import { createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

import { getCommentLockedContent } from '../../../api/comments';

import { generateCommentCIDKey } from '../../../components/Comments/utils/generateCommentCIDKey';
import {
  checkAndSetLoadingWithId,
  handleRequestRejection,
  onMatchedRequest,
} from '../../../utils/asyncThunkRequest';

export const fetchCommentLockedContent = createAsyncThunk(
  'comments/fetchCommentLockedContent',
  async (commentData, { signal, rejectWithValue }) => {
    const source = axios.CancelToken.source();
    signal.addEventListener('abort', () => {
      source.cancel();
    });
    try {
      const response = await getCommentLockedContent(commentData, {
        cancelToken: source.token,
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.status);
    }
  },
);

export const fetchCommentLockedContentExtraReducers = builder => {
  builder
    .addCase(fetchCommentLockedContent.pending, (state, action) => {
      const commentCIDKey = generateCommentCIDKey(action.meta.arg.path);

      checkAndSetLoadingWithId(
        state.comments.commentsLockedContent.request,
        action,
        commentCIDKey,
      );
    })
    .addCase(fetchCommentLockedContent.fulfilled, (state, action) => {
      const commentCIDKey = generateCommentCIDKey(action.meta.arg.path);

      // TODO: check and fix when backend is ready
      onMatchedRequest(
        state.comments.commentsLockedContent.request[commentCIDKey],
        action,
        () => {
          state.comments.comment.byId[commentCIDKey].content = action.payload;
          state.comments.comment.byId[commentCIDKey].metadata.locked = false;
          state.comments.comment.byId[commentCIDKey].unlockPrice = 0;
          state.comments.comment.byId[commentCIDKey].lockedCoins = 0;
        },
      );
    })
    .addCase(fetchCommentLockedContent.rejected, (state, action) => {
      const commentCIDKey = generateCommentCIDKey(action.meta.arg.path);

      handleRequestRejection(
        state.comments.commentsLockedContent.request[commentCIDKey],
        action,
      );
    });
};
